import React from 'react';
import { FaCog, FaPhone, FaEnvelope, FaClock, FaGlobe, FaMapMarkerAlt } from 'react-icons/fa';
import { CONTACT, phoneHref } from '../../constants/contact';
import '../Footer.css';

const CloneFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-brand">
            <a href="#home" className="footer-logo">
              <FaCog className="footer-logo-icon" />
              <div>
                <span className="fl-main">MaxAutoParts</span>
                <span className="fl-sub">by {CONTACT.company}</span>
              </div>
            </a>
            <p>
              Your trusted source for OEM auto parts at prices up to 30% less than dealerships.
              Quality, reliability, and savings — powered by{' '}
              <strong style={{ color: '#FFA500' }}>{CONTACT.company}</strong> at{' '}
              <strong style={{ color: '#FFA500' }}>{CONTACT.website}</strong>.
            </p>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#contact">Contact Us</a></li>
              <li><a href="#products">Products</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Explore</h4>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#brands">Brands</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact Us</h4>
            <div className="footer-contact">
              <div className="fc-item">
                <FaPhone className="fc-icon" />
                <div>
                  <strong>Phone</strong>
                  <a href={phoneHref}>{CONTACT.phone}</a>
                </div>
              </div>
              <div className="fc-item">
                <FaEnvelope className="fc-icon" />
                <div>
                  <strong>Email</strong>
                  <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                </div>
              </div>
              <div className="fc-item">
                <FaMapMarkerAlt className="fc-icon" />
                <div>
                  <strong>Address</strong>
                  <span>{CONTACT.addressLine1}</span>
                  <span>{CONTACT.addressLine2}</span>
                </div>
              </div>
              <div className="fc-item">
                <FaGlobe className="fc-icon" />
                <div>
                  <strong>Website</strong>
                  <a href={CONTACT.websiteUrl} target="_blank" rel="noreferrer">{CONTACT.website}</a>
                </div>
              </div>
              <div className="fc-item">
                <FaClock className="fc-icon" />
                <div>
                  <strong>Hours</strong>
                  <span>{CONTACT.hoursWeekdays}</span>
                  <span>{CONTACT.hoursSaturday}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container footer-bottom-inner">
          <p>
            &copy; 2026 {CONTACT.company}. All rights reserved. | MaxAutoParts &mdash; {CONTACT.website}
          </p>
          <div className="footer-links">
            <a href="#contact">Contact Us</a>
            <a href="#faq">FAQ</a>
            <a href="#products">Products</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CloneFooter;
